
import { defineComponent, ref, reactive, toRefs, onMounted, computed } from 'vue'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
import f10ApiHk from '@/api/f10ApiHk'
import { useRoute } from 'vue-router'

export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => ({})
    },
    pageSourceData: {
      type: Object,
      default: () => ({})
    },
    token: {
      type: String,
      default: ''
    }
  },
  components: { Table, Nodata },
  setup(props, context) {
    const route = useRoute()
    const state = reactive({
      data: [] as any[],
      spinning: true,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      columns: [
        {
          title: '报告期\\指标',
          dataIndex: 'reportDate',
          key: 'reportDate',
          width: '120px',
          align: 'left',
          // customCell: (record: any) => {
          //   return {
          //     style: {
          //       backgroundColor: '#1890ff',
          //       color: '#fff',
          //       fontWeight: 'bold'
          //     }
          //   }
          // }
        },
        {
          title: '归母净利润 (元)',
          dataIndex: 'npParentCompanyOwners',
          key: 'npParentCompanyOwners',
          width: '140px',
          align: 'right'
        },
        {
          title: '营业收入 (元)',
          dataIndex: 'operatingRevenue',
          key: 'operatingRevenue',
          width: '140px',
          align: 'right'
        },
        {
          title: '每股收益 (元)',
          dataIndex: 'basicEps',
          key: 'basicEps',
          width: '120px',
          align: 'right'
        },
        {
          title: '每股净资产 (元)',
          dataIndex: 'netAssetPs',
          key: 'netAssetPs',
          width: '140px',
          align: 'right'
        },
        {
          title: '毛利率',
          dataIndex: 'grossIncomeRatio',
          key: 'grossIncomeRatio',
          width: '100px',
          align: 'right'
        },
        {
          title: '净利率',
          dataIndex: 'netProfitRatio',
          key: 'netProfitRatio',
          width: '100px',
          align: 'right'
        },
        {
          title: 'ROE',
          dataIndex: 'roe',
          key: 'roe',
          width: '100px',
          align: 'right'
        },
        {
          title: '资产负债率',
          dataIndex: 'debtAssetsRatio',
          key: 'debtAssetsRatio',
          width: '120px',
          align: 'right'
        }
      ]
    })
    const pagination = reactive({
      get total() {
        return state.total
      },
      get current() {
        return state.currentPage
      },
      set current(val: number) {
        state.currentPage = val
      },
      get pageSize() {
        return state.pageSize
      },
      set pageSize(val: number) {
        state.pageSize = val
      },
      showSizeChanger: true,
      showTotal: (total: number) => `共${total}条`,
      pageSizeOptions: ['10', '20', '50', '100'],
      onChange: (page: number, pageSize?: number) => {
        state.currentPage = page
        if (pageSize) state.pageSize = pageSize
      },
      onShowSizeChange: (current: number, size: number) => {
        state.currentPage = 1
        state.pageSize = size
      }
    })
    // 格式化表格数据
    const tableData = computed(() => {
      const start = (state.currentPage - 1) * state.pageSize
      const end = start + state.pageSize
      return state.data.slice(start, end).map(item => {
        const reportDate = new Date(item.reportDate)
        const formattedDate = `${reportDate.getFullYear()}-${(reportDate.getMonth() + 1).toString().padStart(2, '0')}-${reportDate.getDate().toString().padStart(2, '0')}`

        return {
          reportDate: formattedDate,
          npParentCompanyOwners: formatNumber(item.index.npParentCompanyOwners.value, '亿'),
          operatingRevenue: formatNumber(item.index.operatingRevenue.value, '亿'),
          // basicEps: item.index.basicEps.value?.toFixed(2) || '-',
          // netAssetPs: item.index.netAssetPs.value?.toFixed(2) || '-',
          // grossIncomeRatio: item.index.grossIncomeRatio.value?.toFixed(2) + '%' || '-',
          // netProfitRatio: item.index.netProfitRatio.value?.toFixed(2) + '%' || '-',
          // roe: item.index.roe.value?.toFixed(2) + '%' || '-',
          // debtAssetsRatio: item.index.debtAssetsRatio.value?.toFixed(2) + '%' || '-'
          basicEps: item.index.basicEps.value ? item.index.basicEps.value.toFixed(2) : '-',
          netAssetPs: item.index.netAssetPs.value ? item.index.netAssetPs.value.toFixed(2) : '-',
          grossIncomeRatio: item.index.grossIncomeRatio.value ? item.index.grossIncomeRatio.value.toFixed(2) + '%' : '-',
          netProfitRatio: item.index.netProfitRatio.value ? item.index.netProfitRatio.value.toFixed(2) + '%' : '-',
          roe: item.index.roe.value ? item.index.roe.value.toFixed(2) + '%' : '-',
          debtAssetsRatio: item.index.debtAssetsRatio.value ? item.index.debtAssetsRatio.value.toFixed(2) + '%' : '-'
        }
      })
    })

    // 数字格式化函数
    const formatNumber = (value: number, unit: string) => {
      if (!value) return '-'
      const num = value / 100000000 // 转换为亿单位
      return num.toFixed(2) + unit
    }

    // 设置行样式
    const setRowClass = (record: any, index: number) => {
      return index % 2 === 0 ? 'even-row' : 'odd-row'
    }

    onMounted(() => {
      const data = {
        data: {
          market: route.query.market || 'HKSE',
          symbol: route.query.code || '00700',
          indexCode: 'npParentCompanyOwners,basicEps,operatingRevenue,netAssetPs,grossIncomeRatio,netProfitRatio,debtAssetsRatio,roe'
        },
        headers: {
          token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944',
        }
      }

      f10ApiHk.getBriefStockFinance(data).then((res: any) => {
        if (res.data?.list) {
          state.total = res.data.total || res.data.list.length
          state.data = res.data.list.sort((a: any, b: any) =>
            b.reportDate - a.reportDate
          )
        }
        state.spinning = false
      }).catch(() => {
        state.spinning = false
      })
    })

    return {
      ...toRefs(state),
      tableData,
      setRowClass,
      pagination
    }
  }
})
